import {CharityLoading, IInternalState} from "./context";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICharity, ICharityDetails} from "../../models/charity/response";
import {ICharityQuery} from "../../models/charity/query";
import paramsReducer, {QueryAction} from "../base/base-reducer";
import toggleLoading from "../../utils/helpers/xor";

type Action =
    | {
    type: "LOADING";
    payload: { loading: CharityLoading | CharityLoading[] };
}
    | { type: "SET_LIST"; payload: { list: IBaseListingResponse<ICharity> } }
    | { type: "SET_DETAILS"; payload: { details?: ICharityDetails } }
    | QueryAction<ICharityQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
    switch (action.type){
        case "LOADING": {
            return {
                ...state,
                loading: toggleLoading(state.loading, action.payload.loading),
            };
        }
        case "SET_LIST": {
            return {
                ...state,
                list: action.payload.list,
            };
        }
        case "SET_DETAILS": {
            return {
                ...state,
                details: action.payload.details,
            };
        }
        default: {
            return paramsReducer(state, action);
        }
    }
}

export default reducer;